module.exports = __webpack_public_path__ + "static/media/Piercing-mouth-ashley.1507a9b2.png";